// React
import { ReactElement } from 'react';
// Modules
import classNames from 'classnames/bind';
// Utils
import { getColorStyle } from '@utmb/utils/colors';
// Interfaces
import { GlobalNavigationMenuLevelView } from '@utmb/types/index';
import { ColorTypesEnum } from '@utmb/types/colors';
import { IconsEnum } from '@utmb/types/icons';
// Design System
import { Font } from '@utmb/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
import { Link } from '@utmb/design-system/link/link';
// Context/Hook
import { useDashboardNavigation } from '@utmb/design-system/use-dashboard-navigation/UseDashboardNavigation';
import { useRouter } from 'next/router';
// Styles
import styles from './mobile-registration-navigation.module.scss';

const cx = classNames.bind(styles);

export const MobileRegistrationNavigation = (): ReactElement | null => {
    const { registrationNavigation } = useDashboardNavigation();
    const { route } = useRouter();

    if (!registrationNavigation?.length) {
        return null;
    }

    const dashboardRoutes = registrationNavigation as unknown as GlobalNavigationMenuLevelView[];

    return (
        <div className={styles.root}>
            <div className={styles.title}>
                <Font.FuturaMedium as="span">MY</Font.FuturaMedium>
                &nbsp;
                <Font.FuturaBold as="span">UTMB</Font.FuturaBold>
                <Icon variant={IconsEnum.USER} color={getColorStyle(ColorTypesEnum.WHITE)} clss={styles.icon} />
            </div>
            <ul className={styles.list}>
                {dashboardRoutes.map(({ id, label, slug }) => (
                    <li key={id} className={styles.list_item}>
                        <Link
                            href="#"
                            className={cx(styles.item_link, {
                                item_link_active: route === slug,
                            })}
                        >
                            <Font.FuturaHeavy mobile="12" className={styles.item_text}>
                                {label}
                            </Font.FuturaHeavy>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};
